<app-page-header
  [pageTitle]="'Registrar nuevo prospecto'"
  [showBreadcrumb]="true"
  [backRoute]="'/crm/prospectos'"
  [backLabel]="'Prospectos'"
  [currentRoute]="'Crear'"
/>

<app-card [title]="'Datos generales'">
  <app-form [formGroup]="saveForm">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
      <div>
        <app-label for="tipo">
          Tipo
        </app-label>
        <app-select id="tipo" formControlName="tipo" placeholder="Seleccione un tipo" [options]="tipoOptions" />
      </div>

      <div>
        <app-label for="param_canal_captacion_id">
          Canal de captación
        </app-label>
        <app-select id="param_canal_captacion_id" formControlName="param_canal_captacion_id" placeholder="Seleccione un canal de captación" [options]="canalesCaptacionOptions" />
      </div>

      <div>
        <app-label for="fecha_solicitud">Fecha de solicitud</app-label>
        <app-input-field id="fecha_solicitud" type="date" formControlName="fecha_solicitud" />
      </div>

      @if (saveForm.get('tipo')?.value === 'F') {
        <div>
          <app-label for="nombre">
            Nombre
          </app-label>
          <app-input-field id="nombre" formControlName="nombre" />
        </div>

        <div>
          <app-label for="apellido">
            Apellido
          </app-label>
          <app-input-field id="apellido" formControlName="apellido" />
        </div>
      } @else {
        <div>
          <app-label for="nombre_empresa">
            Nombre de la empresa
          </app-label>
          <app-input-field id="nombre_empresa" formControlName="nombre_empresa" />
        </div>
      }

      <div>
        <app-label for="documento">
          Documento
        </app-label>
        <app-input-field id="documento" formControlName="documento" />
      </div>

      <div>
        <app-label for="per_documento_tipo_id">
          Tipo de documento
        </app-label>
        <app-select id="per_documento_tipo_id" formControlName="per_documento_tipo_id" placeholder="Seleccione un tipo de documento" [options]="documentosTiposOptions" />
      </div>

      <div>
        <app-label for="telefono">
          Teléfono
        </app-label>
        <app-input-field id="telefono" formControlName="telefono" />
      </div>

      <div>
        <app-label for="email">
          Email
        </app-label>
        <app-input-field id="email" type="email" placeholder="example@gmail.com" formControlName="email" />
      </div>

      <div>
        <app-label for="whatsapp">WhatsApp</app-label>
        <app-input-field id="whatsapp" formControlName="whatsapp" />
      </div>
    </div>

    <div>
      <app-label for="descripcion">Descripción</app-label>
      <app-textarea id="descripcion" formControlName="descripcion" [rows]="4" />
    </div>
  </app-form>
</app-card>

<app-creation-buttons *hasPermission="'prospectos:create'"
  [valid]="saveForm.valid"
  [process]="loading"
  (onCreateClick)="saveProspecto()"
  (onCancelClick)="goBack()"
/>
